import angular from 'angular';
import '../../services/sla';
import '../../services/organization-segment';
import '../../services/errors';

const module = angular.module('whyline.modals.sla', [
  'whyline.services.organization',
  'whyline.services.sla',
  'whyline.services.errors',
]);

const SlaModalController = (
  $scope,
  $uibModalInstance,
  $translate,
  $timeout,
  NotificationService,
  OrganizationService,
  SlaService,
  slaId,
  ErrorService,
  OrganizationSegmentService,
) => {
  'ngInject';

  const arrayRange = (start, stop, step) =>
    Array.from({ length: (stop - start) / step + 1 }, (value, index) => start + index * step);

  $scope.numbersSla = arrayRange(5, 100, 1);

  $scope.sla = {
    name: '',
    appointmentSla: '',
    prioritySla: '',
    spontaneousSla: '',
    spontaneousTree: [],
  };

  $scope.organization = [];
  $scope.organization = OrganizationService.GetCurrent();

  const spontaneousTree = [];

  const init = async () => {
    if (slaId) {
      SlaService.GetSlaById(slaId)
        .then((slaDB) => {
          $timeout(() => {
            const sla = SlaService.Copy(slaDB);
            $scope.sla._id = sla._id;
            $scope.sla.name = sla.name;
            $scope.sla.appointmentSla = sla.appointmentSla.toString();
            $scope.sla.prioritySla = sla.prioritySla.toString();
            $scope.sla.spontaneousSla = sla.spontaneousSla.toString();
            $scope.sla.spontaneousTree = sla.spontaneousTree;
          });
        })
        .catch(ErrorService.handler);
    } else {
      $timeout(() => {
        $scope.sla.spontaneousTree = spontaneousTree;
        $scope.sla.appointmentSla = '5';
        $scope.sla.prioritySla = '5';
        $scope.sla.spontaneousSla = '5';
      });
    }
  };

  $scope.close = () => {
    $uibModalInstance.close('cancel');
  };

  init();
};

module.exports = module.controller('SlaModalController', SlaModalController);
